import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { TooltipPosition } from '../../directives/tooltip.directive';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';

@Component({
    selector: 'lib-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class TooltipComponent {
    tooltip: SafeHtml;

    position: TooltipPosition;

    left: number;

    top: number;

    visible: boolean;

    tooltipId?: string;

    constructor() {
        this.tooltip = '';
        this.position = TooltipPosition.ABOVE;
        this.left = 0;
        this.top = 0;
        this.visible = false;
        this.tooltipId = undefined;
    }
}
